import { AlertTriangle } from "lucide-react";

export const AlertBanner = ({ count }) => {
  if (!count) return null;
  return (
    <div
      className="bg-red-50 border-l-4 border-red-500 text-red-900 p-4 rounded-r-lg shadow-sm flex items-center gap-3 animate-pulse-subtle no-print"
      data-testid="overstay-alert-banner"
    >
      <AlertTriangle className="h-6 w-6 text-red-600 shrink-0" />
      <div className="text-sm sm:text-base">
        <span className="font-bold font-serif-title">Alerte de sécurité :</span>{" "}
        <span className="font-semibold">{count}</span> visiteur{count > 1 ? "s" : ""}{" "}
        présent{count > 1 ? "s" : ""} sur site depuis plus de 4 heures sans départ pointé.
        Vérification requise.
      </div>
    </div>
  );
};
